import { Card } from "react-bootstrap";
import api from "../../../api";
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import config from '../../../config/domainconfig.json';

function TMFooter() {
  const env = api.getEnv();
  const sites = config.ecosystem;
  const getFilename = (site) => {
    if (site.indexOf(".com") > -1) {
      return site.substring(0, 9)
    } else {
      const split = site.split(".");
      const tld = split[2];
      return site.substring(0, 9) + "." + tld
    }
  }
  return (
    <div className="tm-footer">
      <Card.Body>
        <div className="ecosystem">
          {sites.map(site =>
            <a className="site-link" href={`${"https://" + site}`} target="_blank">
              <Image src={`${window.location.origin + "/sites/" + getFilename(site)}.svg?213`} className="brand" />
            </a>
          )}
        </div>
        <span>{env.metaInfo.copyright.replace("© 2021", "© " + new Date().getFullYear())}</span>

      </Card.Body>
    </div>
  );
}

export default TMFooter;